import { jsonHeaders, jsonResult } from "./index.js";
import { BACKEND_SUBDOMAIN as backendPrefix } from "#src/env.js";
import { Sentry } from "#src/glitchtip.js";

async function importLocationsParallel({
  locations,
  pages,
  model,
  reasoning_level,
  organization_id,
}) {
  try {
    const res = await fetch(`${backendPrefix}/ai/import-locations-parallel`, {
      method: "POST",
      headers: jsonHeaders(),
      credentials: "include",
      body: JSON.stringify({
        locations,
        pages,
        model,
        reasoning_level,
        organization_id,
      }),
    });

    return res;
  } catch (error) {
    Sentry.captureException(error);
    return { success: false, error: error.message };
  }
}

async function analyzePagesParallel({
  pages,
  model,
  reasoning_level,
  organization_id,
}) {
  try {
    const res = await fetch(`${backendPrefix}/ai/analyze-pages-parallel`, {
      method: "POST",
      headers: jsonHeaders(),
      credentials: "include",
      body: JSON.stringify({
        pages,
        model,
        reasoning_level,
        organization_id,
      }),
    });

    return jsonResult(res);
  } catch (error) {
    Sentry.captureException(error);
    return { success: false, error: error.message };
  }
}

async function promptLocationsParallel({
  locations,
  prompt,
  model,
  reasoning_level,
  organization_id,
}) {
  try {
    const res = await fetch(`${backendPrefix}/ai/prompt-locations-parallel`, {
      method: "POST",
      headers: jsonHeaders(),
      credentials: "include",
      body: JSON.stringify({
        locations,
        prompt,
        model,
        reasoning_level,
        organization_id,
      }),
    });

    return res;
  } catch (error) {
    Sentry.captureException(error);
    return { success: false, error: error.message };
  }
}

async function importTable({
  clip,
  image,
  model,
  reasoning_level,
  organization_id,
}) {
  try {
    const res = await fetch(`${backendPrefix}/ai/import-table`, {
      method: "POST",
      headers: jsonHeaders(),
      credentials: "include",
      body: JSON.stringify({
        clip,
        image,
        model,
        reasoning_level,
        organization_id,
      }),
    });

    return jsonResult(res);
  } catch (error) {
    Sentry.captureException(error);
    return { success: false, error: error.message };
  }
}

async function readDimension({
  image,
  model = "openai-gpt-5.4-mini",
  reasoning_level = "low",
  organization_id,
}) {
  try {
    const res = await fetch(`${backendPrefix}/ai/read-dimension`, {
      method: "POST",
      headers: jsonHeaders(),
      credentials: "include",
      body: JSON.stringify({
        image,
        model,
        reasoning_level,
        organization_id,
      }),
    });

    return jsonResult(res);
  } catch (error) {
    Sentry.captureException(error);
    return { success: false, error: error.message };
  }
}

export {
  importLocationsParallel,
  promptLocationsParallel,
  importTable,
  analyzePagesParallel,
  readDimension,
};
